import * as React from 'react';
import { DingTalk } from '@/common/DingTalk';
import './App.less';
import { PageComponent } from '@/components/PageComponent';
import { EventHelper } from '@/common/Utils';
import YdyTabBar, { YdyTabBarItem } from '@/components/YdyTabBar';
import { TicketHolderList } from '@/AppStore/SmartMoney/components/TicketHolder';
import YdyScrollView from '@/components/YdyScrollView';
import SelectProjectList from '@/AppStore/SmartMoney/components/SelectProject';

class Me extends React.Component {
  render () {
    return <div></div>
  }
}

interface IndexStateTypes extends AppStateTypes {
  permissions: string[]
}

class App extends PageComponent<any, IndexStateTypes> {
  constructor(props) {
    super(props);
    this.state = {
      permissions: [],
      load: false,
      width: window.innerWidth,
      height: window.innerHeight
    };
  }

  @EventHelper.exec()
  async componentDidMount () {
    super.componentDidMount()
    let permissions = await DingTalk.init()
    this.setState({
      load: true,
      permissions
    })
  }

  renderContent () {
    const { height, permissions } = this.state;
    let tabBarItems: YdyTabBarItem[] = [
      {
        id: '01',
        sort: 1,
        name: '进项',
        size: '22px',
        selectedTab: 'EntryTab',
        badge: 0,
        dot: false,
        renderContent: <SelectProjectList type="Entry" height={height - 50}/>,
        icon: require("@/assets/img/components.svg"),
        selectedIcon: require("@/assets/img/components_HL.svg")
      },
      {
        id: '02',
        sort: 2,
        name: '销项',
        size: '22px',
        selectedTab: 'SalesTab',
        badge: 0,
        dot: false,
        renderContent: <SelectProjectList type="Sales" height={height - 50}/>,
        icon: require("@/assets/img/components.svg"),
        selectedIcon: require("@/assets/img/components_HL.svg")
      },
      {
        id: '00',
        sort: 3,
        name: '票夹',
        size: '22px',
        selectedTab: 'TicketHolderTab',
        badge: 0,
        dot: false,
        renderContent: <TicketHolderList type="all" height={height - 50}/>,
        icon: require("@/assets/img/components.svg"),
        selectedIcon: require("@/assets/img/components_HL.svg")
      },
      {
        id: '04',
        sort: 4,
        name: '我的',
        size: '22px',
        selectedTab: 'MeTab',
        badge: 0,
        dot: false,
        renderContent: <Me />,
        icon: require("@/assets/img/components.svg"),
        selectedIcon: require("@/assets/img/components_HL.svg")
      }
    ]
    let _data: (YdyTabBarItem| undefined)[] = permissions.map(permission => {
      for (let index = 0; index < tabBarItems.length; index++) {
        if (tabBarItems[index].id === permission ) {
          return tabBarItems[index]
        }
      }
      return undefined
    })
    let data: YdyTabBarItem[] = []
    for (let index = 0; index < _data.length; index++) {
      const element = _data[index];
      element && data.push(element)
    }
    data.sort((a, b) => {
      if (a.sort > b.sort) return 1
      if (a.sort < b.sort) return -1
      return 0
    })
    return (
      <YdyScrollView style={{height: height}}>
        <YdyTabBar tabBarItems={data}/>
      </YdyScrollView>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/AppStore/SmartMoney/index/App.tsx